import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { Form, Select, Input } from "antd";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../../helpers/Utils";
import { FlopppyButton } from "../../common/ButtonWithLoading";
import { colors } from "../../../utils/colors";

const translates = {
  LT: {
    "Comment state": "Komentarų būsenos",
    "Comment state is required": "Komentarų būsena privaloma",
    Body: "Komentaras",
    "Body is required": "Komentaras privaloma",
  },
  EN: {
    "Comment state": "Comment state",
    "Comment state is required": "Comment state is required",
    Body: "Body",
    "Body is required": "Body is required",
  },
};

// record_type: ['lost_carts', 'requests']
const ModalCreateComment = ({
  type,
  record_type,
  record_id,
  comment_states,
}) => {
  const lang = record_type == "requests" ? "LT" : "EN";
  const [form] = Form.useForm();
  const utils = useQueryClient();

  const mutationComment = useMutation({
    mutationFn: (body) => {
      return Axios.post(
        `${
          record_type == "lost_carts"
            ? `/api/v1/lost_carts/${record_id}`
            : `/pickups/requests`
        }/create_comment`,
        {
          record_id,
          comment: {
            ...body,
            comment_type: type,
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: async () => {
      console.log("Uzklausa", { record_type, record_id });
      await utils.invalidateQueries([
        record_type,
        record_type == "lost_carts"
          ? { lost_cart_id: record_id }
          : { record_id },
      ]);
      // const actions =
      //   record_type == "lost_carts"
      //     ? [
      //         record_type,
      //         record_type == "lost_carts"
      //           ? { lost_cart_id: record_id }
      //           : { record_id },
      //       ]
      //     : [record_type];

      // await utils.invalidateQueries(actions);
      antdMessageSuccess();
      form.resetFields();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  return (
    <Form
      className="mt-2"
      form={form}
      layout="vertical"
      autoComplete="off"
      onFinish={(values) => {
        mutationComment.mutate(values);
      }}
    >
      <Form.Item
        name="comment_state_id"
        rules={[
          {
            required: true,
            message: translates[lang]["Comment state is required"],
          },
        ]}
      >
        <Select
          options={comment_states.filter(
            ({ comment_type }) => type == comment_type
          )}
          placeholder={translates[lang]["Comment state"]}
        />
      </Form.Item>
      <Form.Item
        name="body"
        rules={[
          { required: true, message: translates[lang]["Body is required"] },
        ]}
      >
        <Input.TextArea placeholder={translates[lang]["Body"]} />
      </Form.Item>
      <Form.Item className="text-right">
        <FlopppyButton
          htmlType="submit"
          loading={mutationComment.isLoading}
          style={{
            backgroundColor:
              lang == "LT" ? colors["orange"] : colors["primary"],
          }}
        />
      </Form.Item>
    </Form>
  );
};

export default ModalCreateComment;
